export const staff = [
  {
    name: "Gabriel Tsunoda",
    image: "/images/team-tsunode.webp",
    description: [
      "Desenvolvedor há mais de 8 anos",
      "Entusiasta NodeJs e ReactJs;",
      "Atuou como Desenvolvedor e Líder Técnico em grandes empresas;",
      "Foco em segurança e performance de aplicações Web.",
    ],
  },

  {
    name: "Fabio Antonio",
    image: "/images/team-fabio.webp",
    description: [
      "Mais de 2 anos como desenvolvedor back-end;",
      "Experiência com automatização de processos;",
      "Conhecimento em várias linguagens, dentre elas python e JavaScript;",
      "Já atuou com tecnologias como Express.js, Django e Flask.",
    ],
  },

  {
    name: "Lucas Jozefovicz",
    image: "/images/team-lucas.webp",
    description: [
      "Especialista em arquitetura backend e Python;",
      "Experiência em gestão de projetos e liderança de equipes de desenvolvimento;",
      "Conhecimento em diversas tecnologias de hardware e software;",
      "Já atuou em grandes, médias e pequenas empresas.",
    ],
  },
  {
    name: "Pedro Hasler",
    image: "/images/team-pedro.webp",
    description: [
      "Desenvolvedor com experiência trabalhando com Python, C#, Java e JavaScript;",
      "Experiências com desenvolvimento de ERP e sistemas de geoprocessamento;",
      "Entusiasta de GoLang;",
      "Ávido contribuidor de projetos Open Source.",
    ],
  },
  {
    name: "Nicole Pimenta",
    image: "/images/team-nicole.webp",
    description: [
      "Desenvolvedora Fullstack, formada pela Kenzie Academy Brasil;",
      "Conhecimento em  todas as tecnologias atuais do curso;",
      "Especialista em front-end, utilizando React;",
      "Foco em aprofundar em conceitos de Javascript Vanilla e como aplicar esses conceitos em tecnologias do desenvolvimento.",
    ],
  },
  {
    name: "Sarah 	Scardini",
    image: "/images/team-sarah.webp",
    description: [
      "Desenvolvedora FullStack, formada pela Kenzie Academy Brasil;",
      "Conhecimento das linguagens JavaScript, TypeScript e Python;",
      "Experiência com desenvolvimento utilizando essas linguagens e frameworks como React e Express;",
      "Mais de 5 anos de experiência na área de ensino.",
    ],
  },
];
